import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_COUNTRIES } from '../types';
import { getCountriesPending, getCountriesFulfilled, getCountriesRejected } from '../actions/getCountriesActions';
import { sendApiRequest, notifyWarning, notifyError } from '../actions';
import generateError from '../utilities/generateError';
import { COUNTRY_MESSAGES } from '../constants/countryMessages';

const createPayload = payload => ({
  method: 'get',
  url: 'country/get',
  onSuccess: [response => (response.data.length === 0 ? notifyWarning(COUNTRY_MESSAGES.NOT_FOUND) : getCountriesFulfilled(response))],
  onError: [
    getCountriesRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getCountriesEpic$ = action$ => action$.pipe(
  ofType(GET_COUNTRIES.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(getCountriesPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getCountriesEpic$;


// WEBPACK FOOTER //
// ./src/epics/getCountriesEpic.js